import * as React from "react";
import "./Identity.scss";
import { Persona, IIdentity } from "azure-devops-ui/Persona";
import { css } from "azure-devops-ui/Util";

export const Identity: React.FC<{
  className?: string;
  image?: string;
  name: string;
  size: number;
  showName?: boolean;
}> = ({ className, image, name, size, showName = true }) => {
  const imageUrl = image || determineImage(name);

  return (
    <div className={css("identity inline-flex-row flex-center", className)}>
      <Persona
        className="identity-image"
        size={size}
        identity={
          {
            entityId: name,
            entityType: "",
            originDirectory: "aad",
            originId: name,
            imageUrl: imageUrl
          } as IIdentity
        }
      />
      {showName && (
        <div className="identity-name font-weight-semibold">{name}</div>
      )}
    </div>
  );
};

function determineImage(name: string): string | undefined {
  if (name.indexOf("Kat") !== -1) {
    return "identities/kat.png";
  }

  if (name.indexOf("Celeste") !== -1) {
    return "identities/celeste.png";
  }

  if (name.indexOf("Lydia") !== -1) {
    return "identities/lydia.png";
  }

  if (name.indexOf("Christopher") !== -1) {
    return "identities/christopher.png";
  }
}
